import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilityService } from 'src/app/services/utility.service';
import { ConfigService } from 'src/app/services/config-service/config-service';
import { Recupero } from 'src/app/models/recupero';
import { RilevazionePresenzeService } from 'src/app/services/rilevazione-presenze-service';
import { Observable, of } from 'rxjs';
import { Docente } from 'src/app/models/didattica/docente';
import { AttivitaReale } from 'src/app/models/didattica/attivita-reale';
import { DidatticaService } from 'src/app/services/didattica-service';
import { RilFilterComponent } from '../ril-filter/ril-filter.component';
import { Corso } from 'src/app/models/didattica/corso';
import { ModalController } from '@ionic/angular';


@Component({
    selector: 'app-recupero-editor',
    templateUrl: './recupero-editor.component.html',
    styleUrls: ['./recupero-editor.component.scss'],
    standalone: false
})
export class RecuperoEditorComponent implements OnInit {
  @ViewChild(RilFilterComponent) annoFilter: RilFilterComponent;
  @Input() recupero: Recupero;

  docente: Docente;

  // elenco delle attivita nella select
  attivita: AttivitaReale[];
  ar;

  anno: string;
  corso: Corso;

  constructor(
    private utilityService: UtilityService,
    public modalCtrl: ModalController,
    private didatticaService: DidatticaService,
    public rilevazionePresenzeService: RilevazionePresenzeService,
    public configService: ConfigService
  ) {}

  ngOnInit() {

  }


  setAnno(value: string) {
    this.resetAttivitaDocente(null);
    if (this.docente) {
      this.caricaAttivita(this.docente, value.split('/')[0]);
    }
  }

  cercaDocente(
    service: RilevazionePresenzeService,
    search: string
  ): Observable<any> {
    console.log('search ' + search);
    return service.cercaDocentePerCognome(search);
  }
  cercaAttivita(
    service: RilevazionePresenzeService,
    search: string
  ): Observable<any> {
    return of({});
  }

  resetAttivitaDocente(event) {
    if (!event || (this.docente && this.docente.nominativo !== (event.target as HTMLInputElement).value)) {
      this.ar = null;
      this.attivita = null;
    }
  }


  selezionaDocente(docente) {
    this.docente = docente;
    this.caricaAttivita(docente, this.getAnno());
    this.ar = null;
  }

  caricaAttivita(docente: Docente, anno: string) {
    this.ar = undefined;
    if (docente) {
      this.didatticaService
        .cercaAttivitaRealiModuli(docente, anno).subscribe((attivita) => {

          if (this.corso) {
            this.attivita = attivita.filter(ar => {
              return (ar.cds[0].id === this.corso.id);
            });
          } else {
            this.attivita = attivita;
          }
        });
    } else { this.attivita = []; }
  }

  arChanges(event: any) {
    console.log('ar', this.ar);
  }

  getAnno(): string {
    if (this.annoFilter) {
      this.anno = this.annoFilter.annoAccademicoCorrente.toString();
      this.anno = this.anno.split('/')[0];
    }
    return this.anno;
  }

  conferma() {
    // imposta i dati sul recupero e chiude la finestra passandoli al chiamante
    if (this.anno && this.docente && this.ar) {
      this.recupero.annoAccademicoConvalida = this.anno;
      this.recupero.docenteConvalida = this.docente;
      this.recupero.insegnamentoConvalida = this.ar;
      this.modalCtrl.dismiss({recupero: this.recupero});
    } else {
      this.utilityService.showHintNoTranslate('valorizzare anno, docente e insegnamento');
    }
  }


}
